import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function ErrorPage() {
  return (
    <div className="min-h-screen flex flex-col justify-between bg-linear-to-b from-gray-100 via-green-100 to-green-700">
      
      {/* Content Wrapper */}
      <div className="w-full">

        {/* Header Section */}
        <header className="px-6 py-8 w-full">
          <h1 className="text-2xl font-bold text-black">FINCA</h1>
        </header>

        <main className="flex flex-col items-center justify-center mt-10 px-6">

          {/* Error Icon */}
          <div className="relative h-24 w-24 bg-black rounded-full flex items-center justify-center mb-16 shadow-2xl">
            <span className="text-white text-6xl font-bold select-none">!</span>
          </div>

          {/* Error Text */}
          <div className="text-center space-y-4 mb-14">
            <h1 className="text-5xl font-bold text-gray-900 tracking-tight">
              OOPS!
            </h1>
            <p className="text-xl font-medium text-gray-800 opacity-90 leading-relaxed">
              We’re sorry, there’s <br /> been an error
            </p>
          </div>

          {/* Back to Home Button */}
          <Link to="/">
            <button className="bg-black text-white mt-8 px-8 py-4 rounded-full flex items-center gap-3 shadow-xl hover:bg-[#194e20] hover:scale-105 active:scale-95 transition-all duration-300 cursor-pointer">
              <Home size={20} className="text-white" />
              <span className="font-bold text-lg">Back To Home</span>
            </button>
          </Link>
        </main>
      </div>

      {/* Copyright Footer */}
      <footer className="px-6 py-6 text-center">
        <p className="text-white opacity-80 text-sm">
          Copyright © 2025 AADA. All rights reserved.
        </p>
      </footer>
    </div>
  );
}